//防止多次提交
function setDisabled(obj) {
	obj.attr('disabled', 'disabled').addClass('disabled').html('正在提交......');
}
function removeDisabled(obj) {
	obj.removeAttr('disabled').removeClass('disabled').html('确认提交');
}

/*表单验证*/
(function() {
	var valitor = $('#sheets').validate({
		errorClass : "validate-error",
		rules:{
			copies:{
				required:true,
				min:1,
				max:1073741824,
				digits:true,
			},
			qq:{
				required:true,
				digits:true,
				minlength:5,
				maxlength:12,
			},
			mobile:{
				required:true,
				mobilePhone: true
        },
      other:{
      	required:true,
      	minlength:4,
      },
      provision:{
      	required:true,
        },
      email:{
      	required:true,
      	email:true,

      }
		},
		messages:{
			copies:{
				max:"你地址购买的报告超过最大限制1073741824份,如需订购请联系客服:400-096-0053",
			},
			provision:"你必须同意以下条款才能提交订单",
			qq:"你的qq号格式不规范",
		}
	});

	$('.submit').on('click', function(event) {
		event.preventDefault();
		var that = $(this);
		setDisabled(that);
		/* Act on the event */
		if ($('#sheets').valid()) {
			$.ajax({
				//url:'/home/index/order',
				type:'post',         
				dataType:'json',  
				data:$("#sheets").serialize(),
			})
			.done(function(data) {
				var data = JSON.parse(data);
				if (data.code=="200") {
					location.href = data.url;
				}else{
					removeDisabled(that);
					alert(data.msg);
				}
			})
			.fail(function() {
				removeDisabled(that);
				alert("订单提交失败,怀疑是网络不好，如你重新提交仍报错，请联络客服：400-096-0053");
			})
			.always(function() {
			});
		}else{
			var firserro = $('#sheets').find('.validate-error').first();
			$(window).scrollTop(firserro.offset().top-30);
			removeDisabled(that);
		}
	});
})();

/*监视购买份数和价格变化 计算总价*/
(function(){
	//控制按钮设置购买份数函数
  /*
  *@param:{string} op (只支持加："+","-")
  */
  function setCount(op){
    var count;
    var copies = $('#copies');

    //防止输入框数量为空不能使用增加按钮
    if (isNaN($('#copies').val())) {
      $('#copies').val(1);
    }

    if (op=="+") {
      count = parseInt(copies.val())+1;
    }else{
      count = parseInt(copies.val())-1; 
    }
    $('#copies').val(count);

    init();
  }
  $('.contrl .add').on('click', function(event) {setCount("+")});
  $('.contrl .del').on('click', function(event) {
  	if ($('#copies').val()>1) {
  		setCount("-");
  	}
  });


  //根据数量计算总金额函数（设置订购报告的最大数量为2^30，防止溢出。）
  function total(count){
    var price = $('input:radio[name="price_id"]:checked').data('price');
    var total = price*count;
    $('.amount b').html(' &yen;'+total);
  }

  //当用户选择的价格或者数量有变化 都要重新计算总金额
  $('#copies').on('input', function(event) {init()});
  $('input:radio[name="price_id"]').on('change', function(event) {init()});

  function init(){
    var count = parseInt($('#copies').val());
    total(count);
 }

 //初始化根据默认值计算总价
 init();
})();





 







// WEBPACK FOOTER //
// ./src/pages/base/order.js